import type { ISerialize } from '@/objects/ISerialize';

export class SignalrProductionDeviceSettingSubscribeParameters implements ISerialize {
    public DeviceID: string;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { DeviceID?: string | null }) {
        this.DeviceID = values.DeviceID ?? '';
    }

    public serialize(): string {
        return '{' + `"DeviceID": ${JSON.stringify(this.DeviceID)}` + '}';
    }

    /**
     * Creates an instance of SignalrProductionDeviceSettingSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { DeviceID?: string | null }): SignalrProductionDeviceSettingSubscribeParameters {
        return new SignalrProductionDeviceSettingSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrProductionDeviceSettingSubscribeParameters {
        return new SignalrProductionDeviceSettingSubscribeParameters({ DeviceID: json.DeviceID ?? '' });
    }

    /**
     * Creates an instance of SignalrProductionDeviceSettingSubscribeParameters from another instance of SignalrProductionDeviceSettingSubscribeParameters.
     * @param other The SignalrProductionDeviceSettingSubscribeParameters you want to clone
     * @returns A cloned SignalrProductionDeviceSettingSubscribeParameters
     */
    public static FromOther(other: SignalrProductionDeviceSettingSubscribeParameters): SignalrProductionDeviceSettingSubscribeParameters {
        return SignalrProductionDeviceSettingSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrProductionDeviceSettingSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrProductionDeviceSettingSubscribeParameters';
}
